import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  Alert,
  Container,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import BadgeIcon from '@mui/icons-material/Badge';

const EnrolledStudents = ({ courseId }) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const res = await fetch(`http://196.216.9.34:5021/course/${courseId}/students`);
        if (!res.ok) throw new Error(`Error: ${res.status}`);
        const data = await res.json();
        setStudents(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [courseId]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Students Enrolled in Course #{courseId}
      </Typography>

      {loading && <CircularProgress color="primary" />}
      {error && <Alert severity="error">Error: {error}</Alert>}

      {!loading && !error && (
        <>
          {students.length === 0 ? (
            <Alert severity="info">No students found.</Alert>
          ) : (
            <Grid container spacing={3}>
              {students.map((student) => (
                <Grid item xs={12} sm={6} md={4} key={student.id}>
                  <Card
                    elevation={6}
                    sx={{
                      borderRadius: 3,
                      height: '100%',
                      bgcolor: '#fdfdfe',
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#4caf50' }}
                      >
                        <BadgeIcon fontSize="small" />
                        ID: {student.id}
                      </Typography>

                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mt: 1,
                          color: '#3f51b5',
                        }}
                      >
                        <PersonIcon fontSize="small" />
                        {student.username}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mt: 1,
                          color: '#9c27b0',
                        }}
                      >
                        <EmailIcon fontSize="small" />
                        {student.email}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}
    </Container>
  );
};

export default EnrolledStudents;
